export enum ScheduleStatus {
  None = 0,
  Started = 1,
  Stopped = 2,
  Interrupted = 3,
}
